module.exports = __webpack_public_path__ + "img/medchem5_illustration_mobile.41de1b3f.jpg";